/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    CANCEL: 'Annuler',
    CONFIRM: 'Confirmer',
    CONFIRM_POLL_RESPONSE: 'Confirmer la réponse',
    CONTINUE: 'Continuer',
    COPY: 'Copie',
    DELETE: 'Supprimer',
    DELETE_MESSAGE: 'Supprimer le message',
    EDIT: 'Éditer',
    FINISH: 'Terminer',
    HIDE_ANSWERS: 'Cacher les réponses',
    LETS_GET_STARTED: 'Bien sûr, on va commencer.',
    MARK_AS_UNREAD: 'Marquer comme non lu',
    REPLY: 'Répondre',
    SEE_ANSWERS: 'Voir les réponses',
    START_SURVEY: 'Commencer le sondage'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'La taille maximale d\'un fichier est de {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'Le sondage a expiré car il existe déjà une campagne pour cette catégorie.',
    ERROR_CREATING_NEW_SUGGESTION:
      'Erreur lors de la création d’une nouvelle offre',
    ERROR_SAVING_PRODUCT_REVIEW:
      'Problème en enregistrant l\'évaluation du produit',
    ERROR_SENDING_MESSAGE: 'Erreur lors de l\'envoi du message',
    ERROR_SUBMITTING_SURVEY: 'Erreur lors de l\'envoi du sondage',
    IMAGE_SIZE_EXCEEDED: 'La taille maximale d\'une image est de {size}MB',
    MESSAGE_ALREADY_READ:
      'Ce message ne peut plus être modifié car il a déjà été lu.',
    UPLOADED_ASSETS_EXCEED: 'Le nombre maximal de fichiers est {limit}',
    VIDEO_SIZE_EXCEEDED: 'La taille maximale d\'une vidéo est de {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Actions',
    ADDITIONAL_COMMENTS_QUESTION: 'Un autre commentaire ?',
    ANSWERED_ON: 'Réponse à {date}',
    CONTACT_OWNER:
      'Un problème est survenu. Veuillez contacter votre responsable',
    CREATE_NEW_CAMPAIGN_SUGGESTION:
      'Cliquez ici pour générer une nouvelle offre',
    EDITED: 'Modifié',
    EXPIRED_ON: 'A expiré le {date}',
    LAST_READ: 'Dernière lecture',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Offre expirée',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ En acceptant, la campagne sera créée et commencera demain.\nTu recevras également demain le message avec l’affiche à partager.\nCette offre sera disponible pendant 3 jours.',
    QUANTITY: 'Quantité',
    REACT: 'Réagir',
    REACTIONS: 'Réactions',
    RESPOND_BY: 'Répondre avant {date}',
    SEE_PRODUCTS: 'Voir les produits',
    SEEN: 'Vu',
    SELECT_ADDRESS: 'Sélectionner une adresse',
    SELECT_ONE_OPTION: 'Choisis une option',
    SELECT_ONE_OR_MORE_OPTION: 'Choisis une ou plusieurs options',
    SENT: 'Envoyé',
    SWIPE_TO_CANCEL: 'Glisser pour annuler',
    TYPE_NEW_MESSAGE: 'Écris un nouveau message',
    VOICE_MESSAGE: 'Message vocal'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Cette action confirmera la commande et il ne sera plus possible de modifier la réponse. Êtes-vous sûr de vouloir continuer ?',
    DELETE_MESSAGE_CONFIRM: 'Es-tu sûr de vouloir supprimer ce message ?',
    GIVE_OPINION_ABOUT_PRODUCT:
      'Tu peux nous dire ce que tu penses de ce produit ?',
    MESSAGE_DELETED: 'Ce message a été supprimé'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
